//Some handy color utils. Been using them since forever.

export const hex2RGB = hx => {
  if (hx == 0 || !hx) {
    return { r: 0, g: 0, b: 0 }
  }
  var o = {}
  o['r'] = (hx >> 16) & 0xff
  o['g'] = (hx >> 8) & 0xff
  o['b'] = hx & 0xff
  return o
}

export const RGB2Hex = o => {
  return (o.r << 16) + (o.g << 8) + o.b
}

export const hex2CSS = hx => {
  if (hx == 0 || !hx) {
    return '#000000'
  }
  var t = '#000000'
  var s = hx.toString(16)
  return t.substring(0, 7 - s.length) + s
}

export const CSS2Hex = strng => {
  var h = strng.slice(1)
  return parseInt(h, 16)
}

export const RGB2CSS = o => {
  return hex2CSS(RGB2Hex(o))
}

export const CSS2RGB = strng => {
  return hex2RGB(CSS2Hex(strng))
}
